module.exports = {
	"job": {
		"lang": "en",
		"user_id": 46548,
		"name": "struggling.mp3",
		"duration": 185,
		"created_at": "Fri Jul 27 20:11:48 2018",
		"id": 8856514
	},
	"speakers": [
		{
			"duration": "184.40",
			"confidence": null,
			"name": "M1",
			"time": "0.34"
		}
	],
	"words": [
		{
			"duration": "0.37",
			"confidence": "0.540",
			"name": "Hey",
			"time": "0.34"
		},
		{
			"duration": "0.18",
			"confidence": "0.980",
			"name": "I've",
			"time": "1.56"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "been",
			"time": "1.74"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "struggling",
			"time": "1.92"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "recently",
			"time": "2.31"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "I've",
			"time": "3.75"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "been",
			"time": "3.87"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "feeling",
			"time": "4.02"
		},
		{
			"duration": "0.63",
			"confidence": "1.000",
			"name": "anxious",
			"time": "4.74"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "stressed",
			"time": "5.61"
		},
		{
			"duration": "0.20",
			"confidence": "1.000",
			"name": "out",
			"time": "6.03"
		},
		{
			"duration": "0.07",
			"confidence": "0.760",
			"name": ".",
			"time": "6.23"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "It's",
			"time": "6.30"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "been",
			"time": "6.48"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "hard",
			"time": "6.66"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "for",
			"time": "6.87"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "me",
			"time": "6.93"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "to",
			"time": "7.08"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "wake",
			"time": "7.14"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "up",
			"time": "7.41"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "in",
			"time": "7.59"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "the",
			"time": "7.68"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "mornings",
			"time": "7.74"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "and",
			"time": "8.16"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "even",
			"time": "8.76"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "harder",
			"time": "9.03"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "to",
			"time": "9.27"
		},
		{
			"duration": "0.18",
			"confidence": "0.870",
			"name": "fall",
			"time": "9.39"
		},
		{
			"duration": "0.41",
			"confidence": "0.870",
			"name": "asleep",
			"time": "9.57"
		},
		{
			"duration": "0.15",
			"confidence": "0.950",
			"name": ".",
			"time": "10.57"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "I'm",
			"time": "10.74"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "not",
			"time": "11.16"
		},
		{
			"duration": "0.27",
			"confidence": "0.970",
			"name": "saying",
			"time": "11.34"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "this",
			"time": "11.61"
		},
		{
			"duration": "0.54",
			"confidence": "1.000",
			"name": "because",
			"time": "11.82"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "I",
			"time": "12.75"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "want",
			"time": "12.84"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "your",
			"time": "12.99"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "pity",
			"time": "13.11"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "or",
			"time": "14.04"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "anything",
			"time": "14.19"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "like",
			"time": "14.52"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "that",
			"time": "14.73"
		},
		{
			"duration": "0.14",
			"confidence": "0.920",
			"name": ".",
			"time": "14.97"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "I'm",
			"time": "15.12"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "doing",
			"time": "15.42"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "pretty",
			"time": "15.72"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "well",
			"time": "15.93"
		},
		{
			"duration": "0.03",
			"confidence": "0.870",
			"name": ".",
			"time": "16.14"
		},
		{
			"duration": "0.09",
			"confidence": "0.980",
			"name": "I'm",
			"time": "16.26"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "taking",
			"time": "16.35"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "care",
			"time": "16.59"
		},
		{
			"duration": "0.06",
			"confidence": "0.990",
			"name": "of",
			"time": "16.74"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "myself",
			"time": "16.80"
		},
		{
			"duration": "0.03",
			"confidence": "0.840",
			"name": ".",
			"time": "17.16"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "But",
			"time": "17.97"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "I",
			"time": "18.90"
		},
		{
			"duration": "0.24",
			"confidence": "0.900",
			"name": "wanted",
			"time": "18.96"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "to",
			"time": "19.20"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "make",
			"time": "19.32"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "this",
			"time": "19.47"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "video",
			"time": "19.62"
		},
		{
			"duration": "0.57",
			"confidence": "1.000",
			"name": "because",
			"time": "20.04"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "I",
			"time": "20.70"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "think",
			"time": "20.76"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "a",
			"time": "20.97"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "lot",
			"time": "21.03"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "of",
			"time": "21.21"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "people",
			"time": "21.27"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "create",
			"time": "21.57"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "unhealthy",
			"time": "22.08"
		},
		{
			"duration": "0.87",
			"confidence": "1.000",
			"name": "perceptions",
			"time": "22.59"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "of",
			"time": "23.46"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "public",
			"time": "23.64"
		},
		{
			"duration": "0.32",
			"confidence": "0.830",
			"name": "figures",
			"time": "24.03"
		},
		{
			"duration": "0.37",
			"confidence": "0.920",
			"name": ".",
			"time": "24.35"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "People",
			"time": "25.98"
		},
		{
			"duration": "0.15",
			"confidence": "0.970",
			"name": "get",
			"time": "26.82"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "these",
			"time": "26.97"
		},
		{
			"duration": "0.72",
			"confidence": "1.000",
			"name": "unrealistic",
			"time": "27.24"
		},
		{
			"duration": "0.99",
			"confidence": "1.000",
			"name": "expectations",
			"time": "27.96"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "that",
			"time": "28.95"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "they",
			"time": "29.10"
		},
		{
			"duration": "0.39",
			"confidence": "0.750",
			"name": "impose",
			"time": "29.19"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "upon",
			"time": "29.58"
		},
		{
			"duration": "0.57",
			"confidence": "1.000",
			"name": "themselves",
			"time": "29.85"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "because",
			"time": "30.45"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "they",
			"time": "31.35"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "see",
			"time": "31.56"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "what",
			"time": "31.80"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "they",
			"time": "31.95"
		},
		{
			"duration": "0.66",
			"confidence": "1.000",
			"name": "think",
			"time": "32.10"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "other",
			"time": "32.88"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "people",
			"time": "33.09"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "are",
			"time": "33.36"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "doing",
			"time": "33.45"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "and",
			"time": "34.38"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "they",
			"time": "34.47"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "try",
			"time": "34.59"
		},
		{
			"duration": "0.09",
			"confidence": "0.950",
			"name": "and",
			"time": "34.77"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "do",
			"time": "34.86"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "it",
			"time": "34.98"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "themselves",
			"time": "35.07"
		},
		{
			"duration": "0.03",
			"confidence": "0.990",
			"name": ".",
			"time": "35.52"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "So",
			"time": "35.58"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "for",
			"time": "35.82"
		},
		{
			"duration": "0.60",
			"confidence": "1.000",
			"name": "example",
			"time": "35.97"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "a",
			"time": "37.41"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "lot",
			"time": "37.47"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "of",
			"time": "37.65"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "people",
			"time": "37.71"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "think",
			"time": "37.98"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "that",
			"time": "38.25"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "I'm",
			"time": "38.40"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "working",
			"time": "38.55"
		},
		{
			"duration": "0.18",
			"confidence": "0.870",
			"name": "you",
			"time": "39.00"
		},
		{
			"duration": "0.18",
			"confidence": "0.870",
			"name": "know",
			"time": "39.18"
		},
		{
			"duration": "0.99",
			"confidence": "1.000",
			"name": "24/7",
			"time": "39.36"
		},
		{
			"duration": "0.96",
			"confidence": "1.000",
			"name": "365",
			"time": "40.35"
		},
		{
			"duration": "0.13",
			"confidence": "0.970",
			"name": "that",
			"time": "41.48"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "I'm",
			"time": "41.61"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "always",
			"time": "41.73"
		},
		{
			"duration": "0.54",
			"confidence": "1.000",
			"name": "attacking",
			"time": "42.78"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "life",
			"time": "43.32"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "and",
			"time": "43.71"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "always",
			"time": "44.04"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "you",
			"time": "44.43"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "know",
			"time": "44.49"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "looking",
			"time": "45.00"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "to",
			"time": "45.27"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "squeeze",
			"time": "45.39"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "more",
			"time": "45.84"
		},
		{
			"duration": "0.69",
			"confidence": "1.000",
			"name": "productivity",
			"time": "46.05"
		},
		{
			"duration": "0.11",
			"confidence": "0.820",
			"name": "in",
			"time": "46.74"
		},
		{
			"duration": "0.38",
			"confidence": "1.000",
			"name": "growth",
			"time": "46.86"
		},
		{
			"duration": "0.08",
			"confidence": "0.560",
			"name": "out",
			"time": "47.24"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "of",
			"time": "47.37"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "every",
			"time": "47.46"
		},
		{
			"duration": "0.66",
			"confidence": "1.000",
			"name": "situation",
			"time": "47.67"
		},
		{
			"duration": "0.06",
			"confidence": "0.970",
			"name": ".",
			"time": "48.33"
		},
		{
			"duration": "0.12",
			"confidence": "0.940",
			"name": "And",
			"time": "48.69"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "the",
			"time": "48.81"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "truth",
			"time": "48.90"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "is",
			"time": "49.20"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "that",
			"time": "49.95"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "I",
			"time": "50.07"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "do",
			"time": "50.16"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "that",
			"time": "50.31"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "a",
			"time": "50.49"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "lot",
			"time": "50.55"
		},
		{
			"duration": "0.11",
			"confidence": "0.510",
			"name": ".",
			"time": "50.82"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "My",
			"time": "51.03"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "everyday",
			"time": "51.27"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "life",
			"time": "51.57"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "I",
			"time": "52.50"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "try",
			"time": "52.77"
		},
		{
			"duration": "0.12",
			"confidence": "0.990",
			"name": "and",
			"time": "53.04"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "live",
			"time": "53.16"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "with",
			"time": "53.76"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "passion",
			"time": "53.91"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "and",
			"time": "54.96"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "I",
			"time": "55.65"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "try",
			"time": "55.71"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "to",
			"time": "55.92"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "live",
			"time": "56.10"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "with",
			"time": "56.28"
		},
		{
			"duration": "0.54",
			"confidence": "1.000",
			"name": "intensity",
			"time": "56.43"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "because",
			"time": "57.00"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "you",
			"time": "57.66"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "know",
			"time": "57.75"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "that's",
			"time": "58.05"
		},
		{
			"duration": "0.22",
			"confidence": "0.960",
			"name": "that's",
			"time": "58.76"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "the",
			"time": "58.98"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "way",
			"time": "59.10"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "that",
			"time": "59.28"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "I",
			"time": "59.91"
		},
		{
			"duration": "0.47",
			"confidence": "1.000",
			"name": "think",
			"time": "60.12"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "I",
			"time": "60.69"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "can",
			"time": "60.84"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "find",
			"time": "60.99"
		},
		{
			"duration": "0.32",
			"confidence": "0.920",
			"name": "happiness",
			"time": "61.23"
		},
		{
			"duration": "0.31",
			"confidence": "0.880",
			"name": ".",
			"time": "61.59"
		},
		{
			"duration": "0.12",
			"confidence": "0.960",
			"name": "And",
			"time": "62.04"
		},
		{
			"duration": "0.15",
			"confidence": "0.800",
			"name": "that's",
			"time": "62.16"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "what",
			"time": "62.31"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "works",
			"time": "62.46"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "for",
			"time": "62.70"
		},
		{
			"duration": "0.13",
			"confidence": "1.000",
			"name": "me",
			"time": "62.85"
		},
		{
			"duration": "0.02",
			"confidence": "0.800",
			"name": ".",
			"time": "62.98"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "But",
			"time": "63.15"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "if",
			"time": "63.60"
		},
		{
			"duration": "0.20",
			"confidence": "0.920",
			"name": "there's",
			"time": "63.75"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "one",
			"time": "63.96"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "thing",
			"time": "64.14"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "that",
			"time": "64.32"
		},
		{
			"duration": "0.14",
			"confidence": "0.920",
			"name": "I've",
			"time": "64.41"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "learned",
			"time": "64.56"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "about",
			"time": "64.74"
		},
		{
			"duration": "0.66",
			"confidence": "1.000",
			"name": "growth",
			"time": "64.98"
		},
		{
			"duration": "0.33",
			"confidence": "0.990",
			"name": "it's",
			"time": "65.76"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "that",
			"time": "66.09"
		},
		{
			"duration": "0.48",
			"confidence": "0.890",
			"name": "rest",
			"time": "66.84"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "is",
			"time": "67.32"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "an",
			"time": "67.56"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "integral",
			"time": "67.65"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "part",
			"time": "68.10"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "of",
			"time": "68.55"
		},
		{
			"duration": "0.20",
			"confidence": "0.490",
			"name": "growth",
			"time": "68.68"
		},
		{
			"duration": "0.14",
			"confidence": "0.970",
			"name": ".",
			"time": "68.88"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "Let",
			"time": "69.96"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "me",
			"time": "70.08"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "explain",
			"time": "70.17"
		},
		{
			"duration": "0.20",
			"confidence": "0.940",
			"name": "it",
			"time": "70.62"
		},
		{
			"duration": "0.34",
			"confidence": "0.930",
			"name": ".",
			"time": "70.83"
		},
		{
			"duration": "0.60",
			"confidence": "1.000",
			"name": "Imagine",
			"time": "71.22"
		},
		{
			"duration": "0.09",
			"confidence": "0.990",
			"name": "I'm",
			"time": "71.82"
		},
		{
			"duration": "0.11",
			"confidence": "0.940",
			"name": "going",
			"time": "71.91"
		},
		{
			"duration": "0.16",
			"confidence": "0.940",
			"name": "to",
			"time": "72.02"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "use",
			"time": "72.24"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "a",
			"time": "72.60"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "sports",
			"time": "72.90"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "analogy",
			"time": "73.38"
		},
		{
			"duration": "0.17",
			"confidence": "1.000",
			"name": "here",
			"time": "73.80"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "but",
			"time": "74.01"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "imagine",
			"time": "74.16"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "that",
			"time": "74.97"
		},
		{
			"duration": "0.17",
			"confidence": "0.910",
			"name": "there's",
			"time": "75.51"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "somebody",
			"time": "75.69"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "who",
			"time": "76.14"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "is",
			"time": "76.35"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "lifting",
			"time": "76.62"
		},
		{
			"duration": "0.57",
			"confidence": "1.000",
			"name": "weights",
			"time": "77.01"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "for",
			"time": "77.64"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "12",
			"time": "77.94"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "hours",
			"time": "78.21"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "a",
			"time": "78.51"
		},
		{
			"duration": "0.23",
			"confidence": "1.000",
			"name": "day",
			"time": "78.57"
		},
		{
			"duration": "0.30",
			"confidence": "0.890",
			"name": "okay",
			"time": "79.55"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "from",
			"time": "79.92"
		},
		{
			"duration": "0.18",
			"confidence": "0.810",
			"name": "8:00",
			"time": "80.46"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "a.m.",
			"time": "80.64"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "to",
			"time": "80.97"
		},
		{
			"duration": "0.24",
			"confidence": "0.890",
			"name": "8:00",
			"time": "81.09"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "p.m.",
			"time": "81.33"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "just",
			"time": "81.87"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "in",
			"time": "82.08"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "the",
			"time": "82.20"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "gym",
			"time": "82.29"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "lifting",
			"time": "82.92"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "weights",
			"time": "83.28"
		},
		{
			"duration": "0.49",
			"confidence": "0.990",
			"name": "constantly",
			"time": "83.55"
		},
		{
			"duration": "0.02",
			"confidence": "0.730",
			"name": ".",
			"time": "84.04"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "No",
			"time": "84.06"
		},
		{
			"duration": "0.45",
			"confidence": "0.900",
			"name": "break",
			"time": "84.31"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "nothing",
			"time": "85.05"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "to",
			"time": "85.35"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "eat",
			"time": "85.50"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "nothing",
			"time": "85.83"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "to",
			"time": "86.10"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "drink",
			"time": "86.22"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "just",
			"time": "86.94"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "wakes",
			"time": "87.15"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "up",
			"time": "87.51"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "lifts",
			"time": "87.99"
		},
		{
			"duration": "0.57",
			"confidence": "1.000",
			"name": "weights",
			"time": "88.29"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "goes",
			"time": "89.01"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "to",
			"time": "89.25"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "bed",
			"time": "89.37"
		},
		{
			"duration": "0.75",
			"confidence": "0.900",
			"name": ".",
			"time": "89.57"
		},
		{
			"duration": "0.09",
			"confidence": "0.930",
			"name": "Would",
			"time": "90.42"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "that",
			"time": "90.51"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "guy",
			"time": "90.69"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "be",
			"time": "91.35"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "strong",
			"time": "91.47"
		},
		{
			"duration": "1.41",
			"confidence": "0.980",
			"name": ".",
			"time": "91.89"
		},
		{
			"duration": "0.24",
			"confidence": "0.970",
			"name": "No",
			"time": "93.31"
		},
		{
			"duration": "0.28",
			"confidence": "0.690",
			"name": ".",
			"time": "93.59"
		},
		{
			"duration": "0.20",
			"confidence": "0.520",
			"name": "Then",
			"time": "93.98"
		},
		{
			"duration": "0.11",
			"confidence": "0.600",
			"name": "that",
			"time": "94.17"
		},
		{
			"duration": "0.16",
			"confidence": "0.600",
			"name": "guy",
			"time": "94.28"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "would",
			"time": "94.44"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "be",
			"time": "94.59"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "injured",
			"time": "94.89"
		},
		{
			"duration": "0.56",
			"confidence": "0.990",
			"name": "immediately",
			"time": "95.40"
		},
		{
			"duration": "0.04",
			"confidence": "0.440",
			"name": "and",
			"time": "95.96"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "probably",
			"time": "96.00"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "wouldn't",
			"time": "96.30"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "make",
			"time": "96.48"
		},
		{
			"duration": "0.20",
			"confidence": "1.000",
			"name": "it",
			"time": "96.78"
		},
		{
			"duration": "0.13",
			"confidence": "0.810",
			"name": "like",
			"time": "96.98"
		},
		{
			"duration": "0.21",
			"confidence": "0.960",
			"name": "two",
			"time": "97.14"
		},
		{
			"duration": "0.57",
			"confidence": "1.000",
			"name": "days",
			"time": "97.35"
		},
		{
			"duration": "0.30",
			"confidence": "0.900",
			"name": ".",
			"time": "97.92"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "Nobody",
			"time": "98.25"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "can",
			"time": "98.52"
		},
		{
			"duration": "0.14",
			"confidence": "1.000",
			"name": "do",
			"time": "98.67"
		},
		{
			"duration": "0.07",
			"confidence": "0.640",
			"name": "it",
			"time": "98.81"
		},
		{
			"duration": "1.11",
			"confidence": "0.980",
			"name": ".",
			"time": "98.88"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "It's",
			"time": "100.02"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "an",
			"time": "100.17"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "extreme",
			"time": "100.26"
		},
		{
			"duration": "0.59",
			"confidence": "1.000",
			"name": "example",
			"time": "100.62"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "but",
			"time": "101.46"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "it",
			"time": "101.73"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "goes",
			"time": "102.09"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "to",
			"time": "102.33"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "show",
			"time": "102.45"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "that",
			"time": "103.44"
		},
		{
			"duration": "0.65",
			"confidence": "0.930",
			"name": "rest",
			"time": "104.02"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "is",
			"time": "104.79"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "what",
			"time": "105.12"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "makes",
			"time": "105.39"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "you",
			"time": "105.60"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "stronger",
			"time": "105.72"
		},
		{
			"duration": "0.04",
			"confidence": "0.600",
			"name": ".",
			"time": "106.23"
		},
		{
			"duration": "0.15",
			"confidence": "0.940",
			"name": "So",
			"time": "106.56"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "you",
			"time": "106.71"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "get",
			"time": "106.86"
		},
		{
			"duration": "0.57",
			"confidence": "1.000",
			"name": "stronger",
			"time": "107.04"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "when",
			"time": "107.70"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "you're",
			"time": "107.85"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "lifting",
			"time": "107.94"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "weights",
			"time": "108.24"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "by",
			"time": "108.78"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "working out",
			"time": "109.38"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "hard",
			"time": "109.86"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "and",
			"time": "110.52"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "then",
			"time": "110.61"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "resting",
			"time": "110.76"
		},
		{
			"duration": "0.62",
			"confidence": "0.940",
			"name": "afterwards",
			"time": "111.19"
		},
		{
			"duration": "0.22",
			"confidence": "0.670",
			"name": "it's",
			"time": "111.89"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "in",
			"time": "112.11"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "the",
			"time": "112.23"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "rest",
			"time": "112.35"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "period",
			"time": "112.65"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "that",
			"time": "113.07"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "you",
			"time": "113.22"
		},
		{
			"duration": "0.25",
			"confidence": "0.540",
			"name": "grow",
			"time": "113.34"
		},
		{
			"duration": "0.16",
			"confidence": "0.720",
			"name": ".",
			"time": "113.63"
		},
		{
			"duration": "0.09",
			"confidence": "0.930",
			"name": "And",
			"time": "114.11"
		},
		{
			"duration": "0.12",
			"confidence": "0.660",
			"name": "I've",
			"time": "114.21"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "found",
			"time": "114.33"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "this",
			"time": "114.57"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "to",
			"time": "114.75"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "be",
			"time": "114.84"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "true",
			"time": "114.96"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "in",
			"time": "115.20"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "all",
			"time": "115.35"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "aspects",
			"time": "115.53"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "of",
			"time": "115.98"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "my",
			"time": "116.04"
		},
		{
			"duration": "0.41",
			"confidence": "1.000",
			"name": "life",
			"time": "116.16"
		},
		{
			"duration": "0.21",
			"confidence": "0.990",
			"name": "be",
			"time": "116.58"
		},
		{
			"duration": "0.12",
			"confidence": "0.990",
			"name": "it",
			"time": "116.79"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "in",
			"time": "117.18"
		},
		{
			"duration": "0.54",
			"confidence": "1.000",
			"name": "sports",
			"time": "117.33"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "or",
			"time": "117.87"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "school",
			"time": "118.02"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "or",
			"time": "118.53"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "work",
			"time": "118.74"
		},
		{
			"duration": "0.83",
			"confidence": "0.950",
			"name": ".",
			"time": "119.22"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "It's",
			"time": "120.09"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "not",
			"time": "120.30"
		},
		{
			"duration": "0.17",
			"confidence": "0.970",
			"name": "the",
			"time": "120.78"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "periods",
			"time": "121.17"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "of",
			"time": "121.59"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "intense",
			"time": "121.77"
		},
		{
			"duration": "0.54",
			"confidence": "1.000",
			"name": "activity",
			"time": "122.19"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "where",
			"time": "122.73"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "I'm",
			"time": "122.94"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "growing",
			"time": "123.03"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": ".",
			"time": "123.45"
		},
		{
			"duration": "0.18",
			"confidence": "0.990",
			"name": "It's",
			"time": "123.93"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "the",
			"time": "124.11"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "periods",
			"time": "124.23"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "of",
			"time": "124.59"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "rest",
			"time": "124.74"
		},
		{
			"duration": "0.37",
			"confidence": "0.910",
			"name": "after",
			"time": "125.19"
		},
		{
			"duration": "0.29",
			"confidence": "0.840",
			"name": ".",
			"time": "125.63"
		},
		{
			"duration": "0.14",
			"confidence": "0.680",
			"name": "Now",
			"time": "126.10"
		},
		{
			"duration": "0.03",
			"confidence": "0.960",
			"name": "I",
			"time": "126.36"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "made",
			"time": "126.39"
		},
		{
			"duration": "0.03",
			"confidence": "0.980",
			"name": "a",
			"time": "126.57"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "mistake",
			"time": "126.60"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "this",
			"time": "127.05"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "year",
			"time": "127.26"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "where",
			"time": "127.47"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "I",
			"time": "128.43"
		},
		{
			"duration": "0.30",
			"confidence": "0.990",
			"name": "didn't",
			"time": "128.52"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "take",
			"time": "128.82"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "any",
			"time": "129.36"
		},
		{
			"duration": "0.62",
			"confidence": "1.000",
			"name": "rest",
			"time": "129.57"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "after",
			"time": "130.38"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "coming",
			"time": "130.68"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "home",
			"time": "130.92"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "from",
			"time": "131.07"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "school",
			"time": "131.25"
		},
		{
			"duration": "0.33",
			"confidence": "0.790",
			"name": ".",
			"time": "131.58"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "I",
			"time": "132.00"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "came",
			"time": "132.06"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "home",
			"time": "132.27"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "from",
			"time": "132.42"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "school",
			"time": "132.60"
		},
		{
			"duration": "0.09",
			"confidence": "0.560",
			"name": "on",
			"time": "133.04"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "Saturday",
			"time": "133.23"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "night",
			"time": "133.68"
		},
		{
			"duration": "0.13",
			"confidence": "0.870",
			"name": "and",
			"time": "134.44"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "took",
			"time": "134.58"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "the",
			"time": "134.73"
		},
		{
			"duration": "0.39",
			"confidence": "0.800",
			"name": "Sunday",
			"time": "134.82"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "off",
			"time": "135.21"
		},
		{
			"duration": "0.15",
			"confidence": "0.990",
			"name": "and",
			"time": "135.63"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "then",
			"time": "135.78"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "I",
			"time": "135.93"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "went",
			"time": "136.02"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "right",
			"time": "136.29"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "to",
			"time": "136.53"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "work",
			"time": "136.65"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "on",
			"time": "137.34"
		},
		{
			"duration": "0.03",
			"confidence": "0.950",
			"name": "a",
			"time": "137.46"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "Monday",
			"time": "137.49"
		},
		{
			"duration": "0.94",
			"confidence": "0.680",
			"name": ".",
			"time": "137.76"
		},
		{
			"duration": "0.24",
			"confidence": "0.990",
			"name": "And",
			"time": "138.72"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "I",
			"time": "139.71"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "think",
			"time": "139.83"
		},
		{
			"duration": "0.20",
			"confidence": "0.930",
			"name": "that",
			"time": "140.12"
		},
		{
			"duration": "0.11",
			"confidence": "0.780",
			"name": "I",
			"time": "141.12"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "needed",
			"time": "141.30"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "a",
			"time": "141.66"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "break",
			"time": "141.72"
		},
		{
			"duration": "0.04",
			"confidence": "0.660",
			"name": ".",
			"time": "142.20"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "To",
			"time": "142.26"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "be",
			"time": "142.38"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "honest",
			"time": "142.53"
		},
		{
			"duration": "0.11",
			"confidence": "0.430",
			"name": "I'd",
			"time": "142.86"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "been",
			"time": "142.98"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "going",
			"time": "143.10"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "really",
			"time": "143.37"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "hard",
			"time": "143.61"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "since",
			"time": "143.91"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "since",
			"time": "144.45"
		},
		{
			"duration": "0.72",
			"confidence": "1.000",
			"name": "January",
			"time": "144.75"
		},
		{
			"duration": "0.39",
			"confidence": "0.740",
			"name": ".",
			"time": "145.47"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "And",
			"time": "145.86"
		},
		{
			"duration": "0.69",
			"confidence": "1.000",
			"name": "mentally",
			"time": "146.01"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "I",
			"time": "146.85"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "was",
			"time": "146.94"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "ready",
			"time": "147.15"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "to",
			"time": "147.45"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "let",
			"time": "147.78"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "that",
			"time": "147.96"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "sink",
			"time": "148.17"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "in",
			"time": "148.47"
		},
		{
			"duration": "0.09",
			"confidence": "0.990",
			"name": "to",
			"time": "148.86"
		},
		{
			"duration": "0.17",
			"confidence": "0.990",
			"name": "let",
			"time": "148.95"
		},
		{
			"duration": "0.43",
			"confidence": "0.710",
			"name": "that",
			"time": "149.12"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "those",
			"time": "149.91"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "lessons",
			"time": "150.15"
		},
		{
			"duration": "0.09",
			"confidence": "0.940",
			"name": "that",
			"time": "150.63"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "I",
			"time": "150.72"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "was",
			"time": "150.78"
		},
		{
			"duration": "0.63",
			"confidence": "1.000",
			"name": "learning",
			"time": "150.96"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "kind",
			"time": "151.74"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "of",
			"time": "151.92"
		},
		{
			"duration": "0.45",
			"confidence": "0.900",
			"name": "straighten",
			"time": "153.12"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "themselves",
			"time": "153.57"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "out",
			"time": "154.05"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "my",
			"time": "154.20"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "mind",
			"time": "154.38"
		},
		{
			"duration": "0.02",
			"confidence": "0.580",
			"name": ".",
			"time": "154.68"
		},
		{
			"duration": "0.12",
			"confidence": "0.980",
			"name": "And",
			"time": "154.71"
		},
		{
			"duration": "0.34",
			"confidence": "0.910",
			"name": "instead",
			"time": "154.84"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "I",
			"time": "155.19"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "just",
			"time": "155.28"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "went",
			"time": "155.49"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "right",
			"time": "155.73"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "back",
			"time": "155.94"
		},
		{
			"duration": "0.23",
			"confidence": "0.910",
			"name": "into",
			"time": "156.21"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "intense",
			"time": "156.45"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "activity",
			"time": "156.87"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "and",
			"time": "157.38"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "eventually",
			"time": "157.92"
		},
		{
			"duration": "0.07",
			"confidence": "0.710",
			"name": "I",
			"time": "158.37"
		},
		{
			"duration": "0.28",
			"confidence": "1.000",
			"name": "burned",
			"time": "158.44"
		},
		{
			"duration": "0.15",
			"confidence": "0.610",
			"name": "out",
			"time": "158.72"
		},
		{
			"duration": "0.13",
			"confidence": "0.920",
			"name": ".",
			"time": "158.88"
		},
		{
			"duration": "0.51",
			"confidence": "0.990",
			"name": "That's",
			"time": "159.54"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "where",
			"time": "160.29"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "I",
			"time": "160.68"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "ended",
			"time": "160.80"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "up",
			"time": "161.04"
		},
		{
			"duration": "0.09",
			"confidence": "0.670",
			"name": ".",
			"time": "161.26"
		},
		{
			"duration": "0.22",
			"confidence": "1.000",
			"name": "I",
			"time": "161.39"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "just",
			"time": "161.61"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "felt",
			"time": "161.88"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "like",
			"time": "162.06"
		},
		{
			"duration": "0.06",
			"confidence": "0.910",
			"name": "I",
			"time": "162.24"
		},
		{
			"duration": "0.24",
			"confidence": "0.990",
			"name": "lost",
			"time": "162.30"
		},
		{
			"duration": "0.63",
			"confidence": "1.000",
			"name": "creativity",
			"time": "162.54"
		},
		{
			"duration": "0.03",
			"confidence": "0.980",
			"name": "I",
			"time": "163.17"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "lost",
			"time": "163.20"
		},
		{
			"duration": "0.54",
			"confidence": "1.000",
			"name": "motivation",
			"time": "163.44"
		},
		{
			"duration": "0.02",
			"confidence": "0.760",
			"name": ".",
			"time": "163.98"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "I",
			"time": "164.01"
		},
		{
			"duration": "0.27",
			"confidence": "0.900",
			"name": "started",
			"time": "164.07"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "feeling",
			"time": "164.34"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "anxious",
			"time": "164.61"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "and",
			"time": "165.06"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "stressed",
			"time": "165.18"
		},
		{
			"duration": "0.12",
			"confidence": "0.890",
			"name": "and",
			"time": "165.60"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "my",
			"time": "166.05"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "mental",
			"time": "166.17"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "health",
			"time": "166.47"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "was",
			"time": "166.71"
		},
		{
			"duration": "0.78",
			"confidence": "1.000",
			"name": "deteriorating",
			"time": "166.89"
		},
		{
			"duration": "0.49",
			"confidence": "0.770",
			"name": ".",
			"time": "167.67"
		},
		{
			"duration": "0.11",
			"confidence": "0.940",
			"name": "And",
			"time": "168.31"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "so",
			"time": "168.42"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "that's",
			"time": "168.54"
		},
		{
			"duration": "0.09",
			"confidence": "0.980",
			"name": "why",
			"time": "168.72"
		},
		{
			"duration": "0.06",
			"confidence": "0.830",
			"name": "I",
			"time": "168.81"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "took",
			"time": "168.87"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "a",
			"time": "169.02"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "few",
			"time": "169.08"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "weeks",
			"time": "169.26"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "off",
			"time": "169.50"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "from",
			"time": "169.68"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "YouTube",
			"time": "169.86"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "these",
			"time": "170.22"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "past",
			"time": "170.40"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "few",
			"time": "170.61"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "weeks",
			"time": "170.79"
		},
		{
			"duration": "0.24",
			"confidence": "0.670",
			"name": ".",
			"time": "171.18"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "I",
			"time": "171.54"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "have",
			"time": "171.63"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "not",
			"time": "171.75"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "been",
			"time": "171.96"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "looking",
			"time": "172.35"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "at",
			"time": "172.68"
		},
		{
			"duration": "0.33",
			"confidence": "0.990",
			"name": "YouTube",
			"time": "172.77"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "one",
			"time": "173.16"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "bit",
			"time": "173.43"
		},
		{
			"duration": "0.42",
			"confidence": "0.830",
			"name": "even",
			"time": "174.09"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "checking",
			"time": "174.87"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "my",
			"time": "175.23"
		},
		{
			"duration": "0.63",
			"confidence": "1.000",
			"name": "analytics",
			"time": "175.50"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "or",
			"time": "176.13"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "anything",
			"time": "176.22"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "like",
			"time": "176.55"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "that",
			"time": "176.76"
		},
		{
			"duration": "0.24",
			"confidence": "0.910",
			"name": "I've",
			"time": "177.12"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "just",
			"time": "177.36"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "been",
			"time": "177.60"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "you",
			"time": "178.11"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "know",
			"time": "178.23"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "cold",
			"time": "178.47"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "turkey",
			"time": "178.77"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "not",
			"time": "179.61"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "worrying",
			"time": "179.82"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "about",
			"time": "180.15"
		},
		{
			"duration": "0.08",
			"confidence": "0.900",
			"name": "it",
			"time": "180.39"
		},
		{
			"duration": "0.03",
			"confidence": "0.770",
			"name": ".",
			"time": "180.47"
		},
		{
			"duration": "0.09",
			"confidence": "0.990",
			"name": "And",
			"time": "181.85"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "I",
			"time": "181.95"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "think",
			"time": "182.01"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "this",
			"time": "182.19"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "is",
			"time": "182.34"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "a",
			"time": "182.46"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "useful",
			"time": "182.52"
		},
		{
			"duration": "0.54",
			"confidence": "1.000",
			"name": "lesson",
			"time": "182.91"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "for",
			"time": "184.17"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "everyone",
			"time": "184.32"
		},
		{
			"duration": "0.03",
			"confidence": "0.940",
			"name": ".",
			"time": "184.71"
		}
	],
	"format": "1.0"
};


//////////////////
// WEBPACK FOOTER
// ./src/struggling.json
// module id = 30
// module chunks = 0